module.exports = __webpack_public_path__ + "static/media/javascript.b0e90558.jpg";